var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCards = function SvgCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 78.09 414.33 71A63.23 63.23 0 0 1 416 85.33v309.34a64.07 64.07 0 0 1-64 64h-15.23l72.9 10.25a42.67 42.67 0 0 0 48.2-36.31l43.05-306.33a42.68 42.68 0 0 0-36.32-48.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352 42.67h-70.33a63.84 63.84 0 0 1 25.18 42l43 306.33a63.56 63.56 0 0 1-11.47 46.3H352a42.67 42.67 0 0 0 42.67-42.66V85.33A42.67 42.67 0 0 0 352 42.67ZM328.77 394l-43-306.33a42.68 42.68 0 0 0-48.18-36.27L47.4 78.09a42.66 42.66 0 0 0-36.26 48.18l43 306.33a42.68 42.68 0 0 0 48.19 36.32l190.13-26.73A42.67 42.67 0 0 0 328.77 394Z"
  })));
};
export default SvgCards;